module.exports = __webpack_public_path__ + "assets/img/serve10.8371afbd.png";